var map = {
	"./currency.svg": 1578,
	"./guides.svg": 1579,
	"./help-desk.svg": 1580,
	"./license.svg": 1581,
	"./medical-card.svg": 1582,
	"./medicine.svg": 1583,
	"./passport.svg": 1584,
	"./vaccinated.svg": 1585,
	"./visa.svg": 1586
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1577;